import Address from 'src/components/Onboarding/Address/Address';

const OnBoarding = () => {
  return <Address />;
};

export default OnBoarding;
